<div @tooltip>
  <img [src]="image" >
</div>
